import React from "react";
import ReactDOM from 'react-dom';
import { Container, Row, Col } from "reactstrap";
import Detect from "../components/Detections/Detect";
import Highlight from "../components/Highlight";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

export const DetectionsComponent = () => {
  const { user } = useAuth0();

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={5}>
          <img
            src={"https://signulationassets.s3.jp-tok.cloud-object-storage.appdomain.cloud/SignToTextIcon.svg"}
            alt="Icon"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
            width="300" 
            height="300"
          />

        


        </Col>
        <Col md>
          <h2>Sign to Text</h2>
          <p className="lead text-muted">Allow access to your web cam and detect signs</p>
        </Col>

      </Row>


      <Row style={{ height: 480}}>
        
        <div><Detect /></div>
       
      </Row>

    

    </Container>
  );
};

export default withAuthenticationRequired(DetectionsComponent, {
  onRedirecting: () => <Loading />,
});
